import * as React from 'react'

import { Box, Button, Select, Text } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import { Panes } from 'modules/core/components/Panes'
import PanesHeader from 'modules/core/components/PanesHeader'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import app from 'modules/core/store/models/app'

class CompanyIdentifierForm extends Form {
  constructor(values: Record<string, unknown>) {
    super(values, {
      employee_company_identifier_strategy: 'string',
    })
  }
}

interface Props {
  companyId: string
}

const CompanyIdentifierSettings = ({ companyId: _companyId }: Props) => {
  const [selectedStrategy, setSelectedStrategy] = React.useState<string>(
    companies.current.attributes.employee_company_identifier_strategy ?? ''
  )
  const form = React.useRef(new CompanyIdentifierForm(companies.current.toJS())).current

  const strategyOptions = [
    {
      value: '',
      label: i18n.t('app_store_v2.apps.employee_onboarding.settings_company_identifier.disabled'),
    },
    {
      value: 'autoincremental',
      label: i18n.t(
        'app_store_v2.apps.employee_onboarding.settings_company_identifier.autoincremental'
      ),
    },
  ]

  const onSubmit = async () => {
    const { success } = await asyncAction(() =>
      companies.current.save({
        employee_company_identifier_strategy: selectedStrategy || null,
      })
    )

    if (!success) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('errors.generic_saving'),
      })
    } else {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.saved_successfully'),
      })
      companies.current.set({
        employee_company_identifier_strategy: selectedStrategy || null,
      })
    }
  }

  return (
    <Panes direction="horizontal" type="naked">
      <PanesHeader
        description={i18n.t(
          'app_store_v2.apps.employee_onboarding.settings_company_identifier.description'
        )}
        illustration="user"
        line
        title={i18n.t('app_store_v2.apps.employee_onboarding.settings_company_identifier.title')}
      />
      <FormComponent onSubmit={onSubmit}>
        <Box gap="s24">
          <FormRow>
            <Box gap="s8">
              <Text.Normal size="400" weight="semibold">
                {i18n.t(
                  'app_store_v2.apps.employee_onboarding.settings_company_identifier.generation_strategy'
                )}
              </Text.Normal>
              <Text.Normal size="200">
                {i18n.t(
                  'app_store_v2.apps.employee_onboarding.settings_company_identifier.generation_strategy_text'
                )}
              </Text.Normal>
              <Select
                options={strategyOptions}
                value={selectedStrategy}
                onChange={(value: string) => setSelectedStrategy(value)}
                missingLabel=""
                selectValue={selectedStrategy}
              />
            </Box>
          </FormRow>
          <Button disabled={!!form.hasErrors} submit>
            {i18n.t('common.submit')}
          </Button>
        </Box>
      </FormComponent>
    </Panes>
  )
}

export default CompanyIdentifierSettings
